import { Typography } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import s from './IconBadgeContent.module.scss';

export enum IconBadgeContentColor {
  info = 'info',
  error = 'error',
}

export type IconBadgeContentProps = {
  color: IconBadgeContentColor;
  isActive?: boolean;
  IconComponent: React.ComponentType<{ className?: string }>;
  count: number;
  className?: string;
};

const IconBadgeContent: React.FC<IconBadgeContentProps> = ({
  color,
  IconComponent,
  count,
  isActive,
  className,
}: IconBadgeContentProps) => {
  return (
    <div
      className={cn(
        className,
        s.iconBadge,
        isActive && s['icon-badge_active'],
        s[`icon-badge_color-${color}`]
      )}
    >
      <IconComponent
        className={cn(
          s.iconBadge__typography,
          isActive && s.iconBadge__typography_active
        )}
      />
      <Typography.Text
        className={cn(
          s.iconBadge__typography,
          isActive && s.iconBadge__typography_active
        )}
      >
        {count}
      </Typography.Text>
    </div>
  );
};

export default React.memo(IconBadgeContent);
